import { render, staticRenderFns } from "./AdminSearchUnmanagedReports.vue?vue&type=template&id=6c64c0b4&scoped=true&"
import script from "./AdminSearchUnmanagedReports.vue?vue&type=script&lang=js&"
export * from "./AdminSearchUnmanagedReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminSearchUnmanagedReports.vue?vue&type=style&index=0&id=6c64c0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64c0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c64c0b4')) {
      api.createRecord('6c64c0b4', component.options)
    } else {
      api.reload('6c64c0b4', component.options)
    }
    module.hot.accept("./AdminSearchUnmanagedReports.vue?vue&type=template&id=6c64c0b4&scoped=true&", function () {
      api.rerender('6c64c0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminSearchUnmanagedReports.vue"
export default component.exports